export class Job {
    name: string;
    description: string;
    running: boolean;
    interruptable: boolean;
}